import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';

var DSCardHeader = function DSCardHeader(_ref) {
  var title = _ref.title,
      action = _ref.action;

  var _convertPropToCssClas = convertPropToCssClassName('card-header'),
      cssClassName = _convertPropToCssClas.cssClassName,
      classNameElement = _convertPropToCssClas.classNameElement;

  return /*#__PURE__*/React.createElement("div", {
    className: cssClassName,
    "data-testid": "card-header"
  }, /*#__PURE__*/React.createElement("span", {
    className: classNameElement('heading')
  }, title), /*#__PURE__*/React.createElement("div", {
    className: classNameElement('pull-right'),
    "data-testid": "ds-card_header-action"
  }, action));
};

var cardHeader = {
  /** card header title */
  title: PropTypes.string.description('card header title'),

  /** action */
  action: PropTypes.node.description('action')
};
DSCardHeader.propTypes = cardHeader;
var DSCardHeaderWithSchema = describe(DSCardHeader);
DSCardHeaderWithSchema.propTypes = cardHeader;

export default DSCardHeader;
export { DSCardHeader, DSCardHeaderWithSchema };
//# sourceMappingURL=DSCardHeader.js.map
